/**
 * iPadかどうかを判定する関数
 *
 * iPad 15.0.2のSafariだと、効果音をJSから再生することができない（参考: DEV_EL2ND-1144）
 * iPadはSafariのみを前提としているため、iPadかどうかのみを検証する
 * */
export const isIPad = (): boolean => {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.includes('ipad') || (ua.includes('macintosh') && 'ontouchend' in document)
}
